export enum TimeZoneType {
  GMT_0 = 'GMT+00 Coordinated Universal Time',
  GMT_5 = 'GMT-05 Eastern Standard Time', // Winter
}
